import type { ModulatorCsId, ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";

import { z } from "zod";

export const backofficeFindThirdPartyAppliancesResponseSchema = z.object({
  appliances: z
    .object({
      csId: z
        .number()
        .transform((s) => s as ModulatorCsId)
        .nullable(),
      hwId: z.number().transform((s) => s as ModulatorHwId),
      name: z.string().nullable(),
    })
    .array(),
});

export type BackofficeFindThirdPartyAppliancesResponse = z.infer<
  typeof backofficeFindThirdPartyAppliancesResponseSchema
>;
